<!--  -->
<template>
  <div class="contaniner" @click="clickOther">
    <div class="top-box">
      <div class="top">
        <div @click="goHome" style="cursor:pointer">广州默尼信息技术有限公司</div>
        <div style="font-size:14px"><span>欢迎您：{{userInfo&&userInfo.email?userInfo.email:''}}</span><span style="margin-left:50px;cursor:pointer" @click="exitLogin">退出</span></div>
      </div>
    </div>
    <div class="middle">
      <div class="left">
        <div @click="changeTab(1)" :class="[activeIndex==1?'active-class':'']">我的主页</div>
        <div @click="changeTab(2)" :class="[activeIndex==2?'active-class':'']">基本设置</div>
        <div @click="changeTab(3)" :class="[activeIndex==3?'active-class':'']">在线充值</div>
      </div>
      <div class="right">
        <div class="title">{{activeIndex==1?'我的主页':(activeIndex==2?'基本设置':'在线充值')}}</div>
        <div v-if="activeIndex==1" class="content">
          当前用户等级：{{ isSupreAdmin ? "管理员" : "注册会员"}}
        </div>
        <div v-if="activeIndex==2" class="content" style="position:relative">
          <div class="content-title">
            <span>我的资料</span>
          </div>
          <div class="content-input" style="margin-top:20px">
            <div class="left-label">邮箱</div><div class="right-box" style="background-color:#eee">{{userInfo&&userInfo.email?userInfo.email:''}}</div>
          </div>
          <div class="content-input">
            <div class="left-label">性别</div>
            <div class="right-box">
              <input type="radio" id="option3" name="option3" value="option3" v-model="option3"><label for="option3" style="margin-left:2px;margin-right:15px;">男</label>
              <input type="radio" id="option4" name="option4" value="option4" v-model="option3"><label for="option4" style="margin-left:2px;">女</label>
            </div>
          </div>
          <div class="content-input">
            <div class="left-label">qq</div><input type="text" id="value2" name="value2" v-model="value2" class="right-box">
          </div>
          <div class="content-input">
            <div class="left-label">电话</div><input type="text" id="value3" name="value3" v-model="value3" class="right-box">
          </div>
          <button class="submit-btn" @click="handleSubmitTwo" type="info">提交</button>
          <div v-if="isSuccess" class="successMsgBox">
            <div class="successMsg"><img src="../../assets/images/success-filling.png" alt=""/><span>保存成功！</span></div>
          </div>
        </div>
        <div v-if="activeIndex==3" class="content">
          <div class="content-title">
            <span>充值支付</span>
          </div>
          <div class="content-item">当前账号：<span>{{userInfo&&userInfo.email?userInfo.email:''}}</span></div>
          <div class="content-item">账户余额：<span style="color:red;font-size:20px;margin-right:10px;">￥0.00</span><span>积分点数：</span><span style="color:red;font-weight:bold">0</span></div>
          <div class="content-item">充值类型：
            <div><input type="radio" id="option1" name="option1" value="option1" checked><label for="option1">金钱</label><span style="color:red;">(1元人民币可重置 10 点积分)</span></div>
          </div>   
          <div class="content-item" style="position:relative">充值金额：
            <div><input type="text" id="value1" name="value1" v-model="value1" class="money"><label for="value1">元</label></div>
            <div v-if="isError" class="errorMsgBox">
              <div class="errorMsg"><div><img src="../../assets/images/warn.png" alt=""/><span>请填写充值金额</span></div></div>
            </div>
          </div>
          <div class="content-item">支付方式：
            <div><input type="radio" id="option2" name="option2" value="option2" checked><img src="http://tianlei-live.oss-cn-shenzhen.aliyuncs.com/alldata/zifu/wx.jpg"/></div>
          </div> 
          <button class="submit-btn" @click="handleSubmit">提交</button>
        </div>
      </div>
    </div>
    <div class="fix-bottom">
      <moni-footer ref="footer"></moni-footer>
    </div>
    <div v-if="showPayModal">
      <payBox  @closeLogin="closeLogin" :fromType="fromType"></payBox>
    </div>
  </div>
</template>

<script>
import moniFooter from '../../components/moniFooter/moniFooter'
import payBox from '../../components/payBox/index'
import http from '../../api/http.js'
import apiUrl from '../../api/apiUrl.js'
import util from '../../api/util.js'
import 'jquery'

export default {
  name: 'newsPage',
  data () {
    return {
     activeIndex:1,
     option1:true,
     option2:true,
     value1:'',
     value2:'',
     value3:'',
     isError:false,
     option3:'option3',
     option4:false,
     isSuccess:false,
     userInfo:{},
     showPayModal:false,
     fromType:'center',
     isSupreAdmin: false
    }
  },

  props: [],

  watch: {
  },

  components: {
    moniFooter,
    payBox,
  },

  computed: {},

  created () {
    
  },
  mounted(){
    let userInfo = localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '{}'
    this.userInfo = JSON.parse(userInfo)
    if (this.userInfo.email == window.Glod.superAdmin.email)  {
      this.isSupreAdmin = true
    } 
    this.option3=this.userInfo&&this.userInfo.sex?(this.userInfo.sex==1?'option4':'option3'):'option3';
    this.value2=this.userInfo&&this.userInfo.qq?this.userInfo.qq:'';
    this.value3=this.userInfo&&this.userInfo.tel?this.userInfo.tel:'';
  },
  methods: {
    goHome(){
      this.$router.push({ name: "Index"});
    },
    exitLogin(){
      console.log('退出登录')
      localStorage.removeItem('userInfo')
      this.$router.push({ name: "Index"});
    },
    closeLogin(){
      this.showPayModal=false;
    },
    changeTab(type){
      this.activeIndex=type
    },
    clickOther(){
      this.isError=false;
    },
    handleSubmit(event){
      console.log('handleSubmit')
      event.preventDefault(); // 阻止默认行为，例如链接跳转
      event.stopPropagation(); // 阻止事件冒泡
      if(this.value1==''||this.value1==null||this.value1==undefined){
        this.isError=true
      }else{
        this.showPayModal=true;
      }
    },
    handleSubmitTwo(){
      this.userInfo.sex=this.option3=='option4'?1:0;//0男1女
      this.userInfo.qq=this.value2
      this.userInfo.tel=this.value3
      localStorage.setItem('userInfo',JSON.stringify(this.userInfo))
      let userList = localStorage.getItem('userList') ? localStorage.getItem('userList') : '[]'
      userList = JSON.parse(userList)
      const index = userList.findIndex(item => item.email === this.userInfo.email);
      if (index >= 0) {
        this.userInfo.password = userList[index].password
        userList[index] = this.userInfo
      } else {
        userList.push(this.userInfo)
      }
      localStorage.setItem('userList', JSON.stringify(userList))
      this.isSuccess=true;
      setTimeout(()=>{
        this.isSuccess=false;
      },1500)
    }
  }
}

</script>
<style lang='scss' scoped>
 .contaniner {
   .fix-bottom{
    position: fixed;
    bottom:0px;
    width:100%;
   }
   .top-box{
    height:50px;
    width:100%;
    font-size:18px;
    background-color:#ff789e;
    color:#fff;
    position: fixed;
    top:0px;
   }
   .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:1200px;
    height:100%;
    box-sizing: border-box;
    margin:0px auto;
    padding:0px 15px;
   }
   .middle{
    width:1200px;
    height:600px;
    margin:80px auto 10px;
    overflow-x:hidden;
    overflow-y:auto;
    position:relative;
    box-sizing: border-box;
   }
   .left{
    border-radius:10px 0px 0px 10px;
    width:200px;
    font-size:16px;
    border-top:1px solid #eee;
    border-left:1px solid #eee;
    position:absolute;
    left:0px;
    z-index:100;
    background-color:#fff;
    overflow: hidden;
    div{
      height:50px;
      line-height:50px;
      cursor: pointer;
      background-color:#ffdfea36;
      border-bottom:1px solid #eee;
      position: relative;
      color:#ff789e;
      &:after{
        position: absolute;
        display: inline-block;
        content:'';
        width:1px;
        height:50px;
        background-color:#eee;
        right:0px;
        top:0px;
      }
    }
   }
   .active-class{
    color:#fff!important;
    background-color:#ff789e!important;
    &:after{
      position: absolute;
      display: inline-block;
      content:'';
      width:1px;
      height:50px;
      background-color:#ff789e!important;
      right:1px;
      top:0px;
    }
   }
   .right{
    border-radius:0px 10px 10px 0px;
    margin-left:200px;
    background-color:#ffdfea36;
    border:1px solid #eee;
    width:1000px;
    height:100%;
    box-sizing: border-box;
    font-size:14px;
    text-align:left;
    box-sizing: border-box;
    .title{
      font-size:35px;
      width:100%;
      padding:25px 20px 20px;
      border:1px solid #eee;
      box-sizing: border-box;
    }
    .content{
      padding:20px;
      box-sizing: border-box;
    }
    .content-item{
      margin-top:20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      img{
        width:82.5px;
        height:30.6px;
      }
      div{
      display: flex;
      align-items: center;
      input{
        margin-right:10px;
      }
      }
    }
    .content-title{
      box-sizing: border-box;
      position: relative;
       &:after{
        position: absolute;
        display: inline-block;
        content:'';
        width:calc(100% - 80px);
        height:1px;
        background-color:#ccc;
        right:1px;
        bottom:0px;
      }
      span{
        display: inline-block;
        height:40px;
        line-height:40px;
        width:80px;
        text-align: center;
        background-color:#fff;
        border-left:1px solid #ccc;
        border-right:1px solid #ccc;
        border-top:1px solid #ccc;
      }
    }
   }
 }
 .submit-btn{
  font-size:14px;
  padding:8px 10px;
  background-color:#ff789e;
  border:1px solid #ffdfea;
  color: #fff;
  width:60px;
  border-radius:5px;
  cursor: pointer;
  margin-top:10px;
  &:hover {border:1px solid #ff789e;}
}
.money{
  height:25px;
  padding:0px 5px;
}
.errorMsgBox{
  position: absolute;
  top:30px;
  left:88px;
  background-color:transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
.successMsgBox{
  position: absolute;
  top:50%;
  left:190px;
  transform: translateY(-50%);
  background-color:#fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.successMsg{
  font-size:14px;
  height:30px;
  padding:5px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border:1px solid #ccc;
  border-radius:8px;
  img{
    width:25px!important;
    height:25px!important;
    margin-right:10px;
  }
}
.errorMsg{
  font-size:14px;
  background-image: url('../../assets/images/dialog2.png');
  width:138px;
  height:60px;
  background-size:100% 100%;
  height:38px;
  padding:5px 20px;
  div{
    display: flex;
    margin-top:13px;
  }
  img{
    width:25px!important;
    height:25px!important;
    margin-right:10px;
  }
}
.content-input{
  border:1px solid #ccc;
  display: flex;
  width:480px;
  height:35px;
  line-height:35px;
  margin-top:12px;
  box-sizing: border-box;
  .left-label{
    width:150px;
    text-align: center;
    border-right:1px solid #ccc;
    box-sizing: border-box;
  }
  .right-box{
    width:330px;
    text-align: left;
    padding:0px 10px;
    box-sizing: border-box;
  }
  input{
    border:none;
  }
  input:hover {border:1px solid #ff789e; outline:none;}
  input:focus {border:1px solid #ff789e; outline:none;}
}
</style>


// WEBPACK FOOTER //
// src/pages/personCenter/index.vue